export default __webpack_public_path__ + "static/media/Aurélio Belém.8575c5b8.jpg";